module.exports = __webpack_public_path__ + "media/img/vca/nome4-c4cb019dff756b1d91090a58bf985ef6.png";